module.exports = __webpack_public_path__ + "static/media/sales team.2af51f03.png";